import styled                   from 'styled-components';

import { LabeledVariants      } from 'src/components/common/labeled';
import { LinkVariants         } from 'src/components/common/link';
import { InputPhoneVariants   } from 'src/components/common/input/input-phone';
import { InputTextboxVariants } from 'src/components/common/input/input-textbox';
import { ButtonVariants       } from 'src/components/common/button';
import { BlockUIVariants      } from 'src/components/common/block-ui';

import { NoteVariants         } from 'src/components/features/auth/reg-start/note';
import { NavBarVariants       } from 'src/components/features/auth/common/nav-bar';

import { cssFlexColumn, 
         themeColors          } from 'src/providers/theme/shared';



export type RegStartLayout = {
  paddings: number[];

  backgroundColor: string;

  navbarVariant: NavBarVariants;
  labeledVariant: LabeledVariants;
  inputPhoneVariant: InputPhoneVariants;
  inputTextboxVariant: InputTextboxVariants;
  noteVariant: NoteVariants;
  requestButtonVariant: ButtonVariants;
  nextButtonVariant: ButtonVariants;
  linkVariant: LinkVariants;
  blockuiVariant: BlockUIVariants;

  gapForm: number;
  gapFormElements: number;
  gapButtons: number;
  gapLabels: number;
}

export const layout_light: RegStartLayout = {
  paddings: [30, 36, 47, 36],

  backgroundColor: themeColors.BackgroundFillLight,

  navbarVariant: 'light',
  labeledVariant: 'light',
  inputPhoneVariant: 'h48light',
  inputTextboxVariant: 'h48light',
  noteVariant: 'light',
  requestButtonVariant: 'h48blueoutline',
  nextButtonVariant: 'h48bluefill',
  linkVariant: 'blue13',
  blockuiVariant: 'light',

  gapForm: 48,
  gapFormElements: 20,
  gapButtons: 16,
  gapLabels: 24,
}

export const layout_dark: RegStartLayout = {
  ...layout_light,
}

export const Screen = styled.div<{
  layout: RegStartLayout,
}>`
  ${cssFlexColumn};
  width: 100vw;
  height: 100dvh;

  padding-top: ${(args) => args.layout.paddings[0]}px;
  padding-bottom: ${(args) => args.layout.paddings[2]}px;

  background-color: ${(args) => args.layout.backgroundColor};
`

export const ScreenBody = styled.div<{
  layout: RegStartLayout,
}>`
  ${cssFlexColumn};
  flex-grow: 2;

  padding-right: ${(args) => args.layout.paddings[1]}px;
  padding-left: ${(args) => args.layout.paddings[3]}px;
`
